export default {
    deviceName: '设备名称',
    deviceNumber: '设备编号',
    recordTime: '记录时间',
    mapViewAll: '地图查看全部',
    distance: '距离',
    flightAltitude: '飞行高度(海拔)',
    positionCoordinates: '位置坐标',
    copyLocationData: '复制位置数据',
    detectionRecord: '探测记录',
}